@if (customRouteData()) {
  <main class="custom-route__container">
    <app-box-1 
      class="custom-route__box-desktop"
      [borderRadius]="32"
    >
      <app-custom-route-desktop />
    </app-box-1>

    @if(saturatedPointAndRouteIndexList().length > 0) {
      <section class="custom-route__saturated-pois">
        <h2 class="saturated-pois__title ci-heading-h2-bold">
          {{ 'Puntos de interés saturados' | translate }}
        </h2>
        
        <ul class="saturated-pois__list">
          @for(point of saturatedPointAndRouteIndexList().slice(0, 4); track point.point.id) {
            <li class="saturated-pois__item">
              <app-card-1 
                [style.view-transition-name]="'saturated-img-' + point.point.id"
                class="item__card"
                [indexCard]="point.index"
                [title]="point.point.title"
                [img]="point.point.img"
                [isSaturated]="checkIsSaturated(point.point)"
                [isVerySaturated]="checkIsVerySaturated(point.point)"
                (click)="goToDetailPage(point.point.id, point.point.type, 'saturated')"
              ></app-card-1>
            </li>
          }
        </ul>
      </section>
    }
  </main>
}


